import React from "react";

import GenericUpper from "../../components/generic-upper";
import api from "../../services/api";
import downloadFile from "../../utils/downloadFile";
import { Container } from "react-grid-system";
import { FiliaisContainer } from "./styles";
import Button from "../../components/button";
import ButtonV2 from "../../components/button/button_v2";
import TableWithLabelBlackV2 from "../../components/TableWithLabelBlack/indexV2";
import { BodyM, TaglineP } from "../../styles/stylesTypography";
import { theme } from "../../styles/theme";
import DotsLoader from "../../components/loader";
import { Link } from "react-router-dom";
import InputSearch from "../../components/input-search";
import ModalFuncaoBloqueada from '../../components/modal/modalFuncaoBloqueada';
import ModalTesteGratisAcabou from '../../components/modal/modalFuncaoBloqueada';

import { store } from "react-notifications-component";

import CardGeral from "../../components/card-geral/index";
import { isTotvs } from "../../services/globalFunctions";
import  IconEdit  from "../../assets/icons/icon-pen-edit.png";

import identifyErrorMenssage from "../../services/identifyErrorMenssage";
export const USER = "@userinfo";
export const VAL = "@validade";

class Filiais extends React.Component {
    state = {
        filiais: [],
        limit: 5,
        loading: true,
        hideButton: false,
        offSet: 0,
        result: "",
        result2: "",
        size_screen: window.screen.width,
        user: JSON.parse(localStorage.getItem(USER)),
        val: JSON.parse(localStorage.getItem(VAL)),
        modalTesteGratis: false,
        modalTesteGratisAcabou: false,
    };

    shouldComponentUpdate(width) {
        let shouldUpdate = this.state.size_screen !== width;
        return shouldUpdate;
    }

    componentDidUpdate(){
        this.size_screen = window.screen.width
    }

    componentDidMount() {
        const {user} = this.state;
        setInterval(async()=>{
            this.setState({size_screen: window.screen.width});
        }, 990);
        this.shouldComponentUpdate(window.screen.width);
        this.getFiliais();
    }

    updateValues = async (text, estado, search) => {
        if (search == 1) {
            if(!text && !estado){
                this.search('', '', 30, 0);
            }else{   
                this.setState({ result2: estado });
                this.setState({ result: text });
                this.search(text, estado, 30, 0);
            }
        }else{
            this.setState({result: text});
            this.setState({result2: estado});

        }
    }

    getFiliais = async () => {
        try {
            const { limit, offSet } = this.state;
            const response = await api.get("/filiais?limit=" + limit + "&offset=" + offSet);
            const filiais = response.data.data;
            
            if (filiais && filiais.length > 0) {
                this.setState({ filiais, loading: false, hideButton: false });
            } else {
                this.setState({ filiais: [filiais], loading: false, hideButton: false });
            }


            
        } catch (e) {

        }
    };

    getRelatorio = async () => {
        this.setState({ loading: true });
        window.onbeforeunload = () => 'Seu relatório está sendo gerado. Tem certeza que deseja sair?';
        try {
            const response = await api.get("filiais/relatorio");

            if (response.data.downloadUrl) {
                await downloadFile(response.data.downloadUrl, 'relatorio-filiais.xlsx');
            }

            store.addNotification({
                title: "Sucesso!",
                message: "Relatório gerado com sucesso.",
                type: "success",
                insert: "top",
                container: "top-right",
                animationIn: ["animated", "fadeIn"],
                animationOut: ["animated", "fadeOut"],
                dismiss: { duration: 6000, onScreen: true }
            });
        } catch (error) {
            store.addNotification({
                title: "Erro!",
                message: (
                    <>
                        {identifyErrorMenssage(error)}
                    </>
                ),
                type: "danger",
                insert: "top",
                container: "top-right",
                animationIn: ["animated", "fadeIn"],
                animationOut: ["animated", "fadeOut"],
                dismiss: { duration: 5000, onScreen: true }
            });
        } finally {
            this.setState({ loading: false });
            window.onbeforeunload = null;
        }
    };

    search = async (result, result2, limit, offset) => {
        try {
            const texto = result || '';
            const estado = result2 || '';

            if (texto.length < 1 && estado.length < 1) {
                return;
            }

            const response = await api.get("/filiais");
            let filtredFiliais = response.data.data || [];

            if (estado) {
                // Garante filtrar apenas pela UF selecionada
                filtredFiliais = filtredFiliais.filter(local => {
                    return String(local.estado || '').toUpperCase() === String(estado).toUpperCase();
                });
            }

            if (texto) {
                // Filtro por cidade contém (case-insensitive)
                filtredFiliais = filtredFiliais.filter(city => {
                    return (city.cidade || '').toLocaleLowerCase().includes(texto.toLocaleLowerCase());
                });
            }

            this.setState({
                hideButton: true,
                filiais: filtredFiliais
            });
        } catch (error) {
        }
    };

    cleanFilter = () => {
        this.setState({
            result: "",
            result2: "",
            offSet: 0
        });
        this.getFiliais();
    };

    LoadMore = async () => {
        this.setState({ loading: true, hideButton: true });
        const { filiais, limit, offSet } = this.state;
        const newOffset = limit + offSet;

        try {
            
            const response = await api.get(
                "/filiais?limit=" + limit + "&offset=" + newOffset
            );
            let newfiliais = response.data.data;
            
            const filiaisConCat = filiais.concat(newfiliais);
            
            this.setState({
                filiais: filiaisConCat,
                offSet: newOffset,
                hideButton: false
            });
        } catch (erro) {
            this.setState({
                hideButton: true
            });
        }
        this.setState({ loading: false });
    };

    onKeyDown = (e) => {
        if (e.key === 'Enter') {
            e.preventDefault();
            e.stopPropagation();
            this.search(this.state.result, this.state.result2, 30, 0);
        }
    }

    showModal = () => {
        this.setState({modalTesteGratis: true});
    }

    render() {
        const { filiais, loading, hideButton, result, user, size_screen, modalTesteGratis, modalTesteGratisAcabou, val } = this.state;

        return (
            <>
                <GenericUpper
                    title="Cadastros"
                    subtitle="Gerencie sua empresa e filiais"
                    search={true}
                    estados={true}
                    searchFunction={(text, estado, search) => this.updateValues(text, estado, search)}
                    onKeyDown={(e) => this.onKeyDown(e)}
                    addButton={!isTotvs() ? true : false}
                    disabled={isTotvs()}
                    tooltip={"Adicionar"}
                    placeholder={'Cidade'}
                    linkSearch={user.contract_software_id == 6 ? ()=>this.showModal() : '/filiais/add'}
                ></GenericUpper>
                
                <FiliaisContainer>
                    <Container style={{}}>
                        <TableWithLabelBlackV2
                            actionsColumn={{
                                enabled: true,
                                label: 'AÇÕES',
                                width: '100%',
                                minWidth: '100px',
                                maxWidth: '100px',
                                position: 'first',
                                render: (filial) => (
                                    <div
                                        style={{width: '100%', cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'flex-start' }}
                                        onClick={(e) => {
                                            e.stopPropagation();
                                            if (user.contract_software_id == 6 && val == 0) {
                                                this.setState({ modalTesteGratisAcabou: true });
                                            } else {
                                                this.props.history.push(`filiais/${filial.id}`);
                                            }
                                        }}
                                    >
                                        <img src={IconEdit} alt="Editar" width="16px" height="16px" />
                                    </div>
                                )
                            }}
                            columns={[
                                {
                                    key: 'nome_fantasia',
                                    label: 'Nome',
                                    width: '100%',
                                    minWidth: '200px',
                                    maxWidth: '400px',
                                    maxWidthContent: '400px',
                                    enableHorizontalScroll: true,
                                    render: (f) => (
                                        <BodyM color={theme.colors.gray.Cinza_2} fontWeight={800}>{f.nome_fantasia}</BodyM>
                                    )
                                },
                                {
                                    key: 'empresa',
                                    label: 'Empresa',
                                    width: '100%',
                                    minWidth: '120px',
                                    maxWidth: '250px',
                                    render: (f) => (
                                        <TaglineP fontWeight={600}>
                                            {f.is_matriz === 1 ? 'Matriz' : 'Filial'}
                                        </TaglineP>
                                    )
                                },
                                {
                                    key: 'cidade',
                                    label: 'Cidade',
                                    width: '100%',
                                    minWidth: '150px',
                                    maxWidth: '250px',
                                    maxWidthContent: '250px',
                                    enableHorizontalScroll: true,
                                    render: (f) => (
                                        <TaglineP color={theme.colors.gray.Cinza_2} fontWeight={600}>{f.cidade}</TaglineP>
                                    )
                                },
                                {
                                    key: 'estado',
                                    label: 'Estado',
                                    width: '100%',
                                    minWidth: '100px',
                                    render: (f) => (
                                        <div style={{
                                            display: 'inline-flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            padding: '4px 12px',
                                            borderRadius: '10rem',
                                            backgroundColor: theme.colors.gray.Cinza_2,
                                            color: '#fff',
                                            fontSize: '11px',
                                            fontWeight: '700',
                                            letterSpacing: '0.5px',
                                            whiteSpace: 'nowrap'
                                        }}>
                                            {f.estado}
                                        </div>
                                    )
                                }
                            ]}
                            data={filiais.filter(f => f.id)}
                            showAll={true}
                            serverSide={true}
                            isLoading={loading}
                            itemsPerPage={filiais.length || 5}
                            enableDefaultRowNavigation={false}
                            emptyMessage="Nenhum resultado encontrado."
                        />


                        <div className="botoesfinais">

                            {filiais.length >= 5 ? (
                                // <Button
                                // style={{outline:0}} 
                                // className="loadmore"
                                // hide={hideButton}
                                // outline
                                // onClick={this.LoadMore}
                                // color="#00b43f"
                                // >
                                //     VER MAIS
                                // </Button>

                                <ButtonV2
                                    width="120px"
                                    height="48px"
                                    outline
                                    value="VER MAIS"
                                    onClick={this.LoadMore}
                                />
                            ):(null)}

                            {/* <Button
                                style={{outline:0}} 
                                className="relatorio"
                                onClick={this.getRelatorio}
                                outline
                                color="#00b43f"
                                >
                                Relatório
                            </Button> */}

                            <ButtonV2
                                width="120px"
                                height="48px"
                                outline
                                value="Relatório"
                                onClick={this.getRelatorio}
                            />
                        </div>

                        <ModalTesteGratisAcabou
                            show={modalTesteGratisAcabou}
                            title="Essa é uma função exclusiva para assinantes..."
                            subtitle="Assine o Agroreceita para desbloquear todos os recursos abaixo:"
                            onHide={() => {
                                this.setState({modalTesteGratisAcabou: false})
                                window.location.href="/"
                            }}
                        ></ModalTesteGratisAcabou>

                        <ModalFuncaoBloqueada
                            show={modalTesteGratis}
                            onHide={() => {
                                this.setState({modalTesteGratis: false})
                                window.location.href="/"
                            }}
                        ></ModalFuncaoBloqueada>
                    </Container>
                </FiliaisContainer>
            </>
        );
    }
}

export default Filiais;
